// src/components/ThirdPartyContact/Components/ThirdPartyContactFormConfig.js
export const steps = ["Add Contact Info", "Add Endpoint"];

export const fields = [
  {
    name: "Fullname",
    key: "fullName",
    type: "text",
    placeholder: "Enter Name",
    validation: "required",
  },
  {
    name: "Email Address",
    key: "email",
    type: "email",
    placeholder: "Enter Email Address",
    validation: "required",
  },
];

export const channelOptions = ["mobile", "whatsapp", "teams"];
